import * as Yup from 'yup'

const workorderSchema = Yup.object({
    title:Yup.string().required('INPUT.VALIDATION.WORKORDER.ADD.TITLE'),
    customer_id:Yup.string().required('INPUT.VALIDATION.WORKORDER.SELECT.CUSTOMER'),
    customer_location_id:Yup.string().required('INPUT.VALIDATION.WORKORDER.SELECT.LOCATION'),
    checklist_id:Yup.string().required('INPUT.VALIDATION.WORKORDER.SELECT.CHECKLIST'),
    cleaner_id:Yup.string(),
    type:Yup.string().required('INPUT.VALIDATION.WORKORDER.SELECT.TYPE'),
    time_for_work_completion:Yup.number().min(1, 'INPUT.VALIDATION.WORKORDER.TIMEFORWORKCOMPLETION').required('INPUT.VALIDATION.WORKORDER.TIMEFORWORKCOMPLETION'),
    pay_type:Yup.string().required('INPUT.VALIDATION.WORKORDER.SELECT.PAY'),
    pay_type_rate:Yup.string().required('INPUT.VALIDATION.WORKORDER.PAY.TYPE.RATE').test('Valid Rate','INPUT.VALIDATION.WORKORDER.PAY.TYPE.VALID.RATE', (value)=>{
        const rate = parseFloat(value)   
        if(rate<1){
                return false
        }
        else{
            return true
        }
    }),
    job_type:Yup.string().required('INPUT.VALIDATION.WORKORDER.SELECT.JOBTYPE'),
    entry_time:Yup.string().required('INPUT.VALIDATION.WORKORDER.ENTRYTIME').nullable(),
    exit_time:Yup.string().required('INPUT.VALIDATION.WORKORDER.EXITTIME').test('Different Entry Exit Time','INPUT.VALIDATION.WORKORDER.EXITTIME.SAME',(value, context)=>{
        const entryTime = context?.parent?.entry_time
        if(!value || !entryTime){
            return true
        }
        return value !== entryTime
    }),
    description:Yup.string(),
    one_time_date:Yup.string(),
    enter_date:Yup.string(),
    recurring:Yup.boolean().required('INPUT.VALIDATION.WORKORDER.SELECT.TYPE'),
    repeat_every:Yup.string(),
    recurrence:Yup.boolean(),
    repeat_on:Yup.array().nullable(),
    ends: Yup.object({}).nullable()
})
export default workorderSchema;
